import { RootState } from '../../rootReducer';

export const annotationsSelectors = {
  getAnnotations: (state: RootState) => state.AnnotationsState.annotations,
  getAnnotationsByBook: (state: RootState) =>
    state.AnnotationsState.annotations?.filter(
      (anno) => anno.book === state.ReaderState.readerData.bookId
    ),
  getAnnotationById: (state: RootState, id: string) =>
    state.AnnotationsState.annotations.find((anno) => anno.id === id),
  getAnnotationByPage: (state: RootState, pageNumber: number) =>
    state.AnnotationsState.annotations.filter(
      (anno) => anno && anno.location && anno.location.pageNumber === pageNumber
    ),

  getAnnotationByBookAndPage: (state: RootState, pageNumber: number) =>
    state.AnnotationsState.annotations?.filter(
      (anno) =>
        anno &&
        anno.location &&
        anno.book === state.ReaderState.readerData.bookId &&
        anno.location.pageNumber === pageNumber
    ),
  getSelectedAnnotation: (state: RootState) =>
    state.AnnotationsState.selectedAnnotation,
  getCurrentlyDrawing: (state: RootState) =>
    state.AnnotationsState.currentlyDrawing,
  getCurrentTool: (state: RootState) => state.AnnotationsState.currentTool,
  getUnfilteredAnnotations: (state: RootState) =>
    state.AnnotationsState.annotationsUnfiltered,
  getAnnotationOptions: (state: RootState) => state.AnnotationsState.options,
  getAnnotationFilters: (state: RootState) =>
    state.AnnotationsState.annotationFilters,
};
